enum SolutionType {
    NONE = 'NONE',
    MOCK = 'MOCK',
    HTML5 = 'HTML5',
    HTML5_FAIRPLAY = 'HTML5_FAIRPLAY',
    SHAKA = 'SHAKA',
    HAS_PLAYER = 'HAS_PLAYER'
}

export default SolutionType;